export default "__VITE_ASSET__1c145355__"